<template>
  <div class="card-list-container">
    <div v-if="loading">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      v-else
      class="card-list-box">
      <div
        v-if="!isEmpty"
        class="card-list-content-box">
        <div
          v-if="isCheckAllVisible"
          class="common-checkbox-box">
          <el-checkbox
            class="checkbox-primary"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange">
            全选
          </el-checkbox>
        </div>
        <div
          class="list-box"
          v-infinite-scroll="handleScroll"
          :infinite-scroll-distance="20">
          <div
            v-for="(item, index) in sceneList"
            :key="index"
            :class="getListItemClassName(item)">
            <div class="expired-box">
              <span class="text-box">已过期</span>
            </div>
            <div
              class="img-box"
              :ref="`img-${item.sceneId}`">
              <div
                class="mask-box"
                v-if="item.status === 2 || item.status === 3">
                <Spin
                  :pointNum="8"
                  :translateX="25"
                  background="var(--base-primary-bgColor)" />
              </div>
              <img
                v-if="item.thumbnail"
                :src="`${imageBaseUrl}/${item.thumbnail}?token=${getTokenId()}`"
                @click="viewScene(item)"
                @error="showImg" />
              <img
                v-else
                :src="getSceneDefaultImg()"
                @click="viewScene(item)" />
              <div
                class="default-view-box"
                v-if="item.defaultViewStatus === 1">
                默认
              </div>
              <div
                :class="`common-checkbox-box ${
                  isSceneChecked(item) ? 'active' : ''
                }`">
                <el-checkbox
                  class="checkbox-primary"
                  :value="isSceneChecked(item)"
                  @change="checked => handleCheckChange(item, checked)" />
              </div>
              <div
                class="operation-button-box"
                v-if="isChecked('Project.Single.Scene.Edit')">
                <div
                  title="编辑"
                  @click="editScene(item)"
                  class="edit-sence">
                  <icon-svg
                    size="14"
                    icon-class="icon-bianjichangjing"
                    class="icon" />
                </div>
              </div>
              <div
                class="time-box"
                @click="viewScene(item)">
                <p class="time-box-item">
                  <span> 创建日期：</span>
                  <span>{{ formatTime(item.creationTime) }}</span>
                </p>
                <p class="time-box-item">
                  <span> 更新日期： </span>
                  <span>
                    {{
                      item.lastModificationTime
                        ? formatTime(item.lastModificationTime)
                        : formatTime(item.creationTime)
                    }}
                  </span>
                </p>
              </div>
              <div
                v-if="item.convertStatusDes"
                class="convert-content-box text-overflow write-text"
                :title="item.convertStatusDes">
                {{ item.convertStatusDes }}
              </div>
            </div>
            <div class="scene-info-box">
              <div class="scene-name-box">
                <div class="icon-box">
                  <icon-svg
                    v-if="item.displayMode === 'Sphere'"
                    size="16"
                    icon-class="ic-sphere"
                    title="三维球体" />
                  <icon-svg
                    size="16"
                    v-if="item.displayMode === 'Plane'"
                    icon-class="ic-plane"
                    title="平面" />
                </div>
                <div
                  class="text-overflow name-box"
                  :title="item.sceneName">
                  {{ item.sceneName }}
                </div>
              </div>
              <div class="status-operation">
                <div
                  class="status-box"
                  v-if="item.status === 0">
                  <div class="circle bg-color1"></div>
                  <span class="color1">未发布</span>
                  <el-tooltip
                    :effect="$theme.tooltipKey()"
                    v-if="item.latestConvertStatus === 4"
                    placement="top-start"
                    popper-class="common-panel-tooltip-box">
                    <div slot="content">该场景最近一次未发布成功</div>
                    <div class="icon-box">
                      <icon-svg
                        size="14"
                        icon-class="ic-wenhao1"
                        class="color3" />
                    </div>
                  </el-tooltip>
                </div>
                <div
                  class="status-box"
                  v-if="item.status === 2 || item.status === 3">
                  <div class="circle bg-color2"></div>
                  <span class="color2">发布中</span>
                </div>
                <div
                  class="status-box"
                  v-if="item.status === 1">
                  <div class="circle bg-color4"></div>
                  <span class="color4">已发布</span>
                  <el-tooltip
                    :effect="$theme.tooltipKey()"
                    v-if="item.latestConvertStatus === 4"
                    placement="top-start"
                    popper-class="common-panel-tooltip-box">
                    <div slot="content">该场景最近一次未发布成功</div>
                    <div class="icon-box">
                      <icon-svg
                        size="14"
                        icon-class="ic-wenhao1"
                        class="color3" />
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    :effect="$theme.tooltipKey()"
                    v-if="
                      item.latestConvertStatus === 1 &&
                      (item.hasDataSetUpdate || item.hasClUpdate)
                    "
                    placement="top-start"
                    popper-class="common-panel-tooltip-box">
                    <div slot="content">该场景发布后有更新</div>
                    <div class="icon-box">
                      <icon-svg
                        icon-class="ic-jiancegengxin"
                        class="color4" />
                    </div>
                  </el-tooltip>
                </div>
                <div
                  v-if="isEditVisible(item)"
                  class="common-dropdown-box"
                  @mouseleave="changeStatus(item, false)">
                  <el-dropdown
                    class="more-info"
                    placement="bottom-start"
                    @command="command => moreOperate(command, item)">
                    <!-- @click="changeStatus(item, true)" -->
                    <div
                      class="more-info-title"
                      title="更多">
                      <i class="el-icon-more"></i>
                    </div>
                    <el-dropdown-menu
                      slot="dropdown"
                      class="common-dropdown-menu dropdown-primary custom-dropdown-primary-sceneList">
                      <!-- @mousemove="changeStatus(item, true)" -->
                      <div @mouseleave="changeStatus(item, false)">
                        <el-tooltip
                          :effect="$theme.tooltipKey()"
                          v-if="item.status !== 1"
                          placement="left"
                          :offset="-3">
                          <div slot="content">请先编辑并发布场景</div>
                          <div
                            :class="`dropdown-item-box ${
                              item.status !== 1 ? 'is-disabled' : ''
                            }`"
                            v-if="isChecked('Project.Single.Scene.Share')">
                            <el-dropdown-item
                              command="1"
                              :disabled="item.status !== 1">
                              分享
                            </el-dropdown-item>
                          </div>
                        </el-tooltip>
                        <div v-else>
                          <div
                            class="dropdown-item-box"
                            v-if="isChecked('Project.Single.Scene.Share')">
                            <el-dropdown-item command="1">
                              分享
                            </el-dropdown-item>
                          </div>
                        </div>
                        <!-- <div
                            class="dropdown-item-box"
                            v-if="isChecked('Project.Single.Scene.Copy')"
                          >
                            <el-dropdown-item command="2">复制</el-dropdown-item>
                          </div> -->
                        <div
                          class="dropdown-item-box"
                          v-if="isChecked('Project.Single.Scene.Delete')">
                          <el-dropdown-item command="3">删除</el-dropdown-item>
                        </div>
                        <div
                          class="dropdown-item-box"
                          v-if="isChecked('Project.Single.Scene.SetThumbnail')">
                          <el-dropdown-item command="4">
                            编辑基本信息
                          </el-dropdown-item>
                        </div>

                        <el-tooltip
                          :effect="$theme.tooltipKey()"
                          v-if="
                            item.status !== 1 || item.defaultViewStatus === 1
                          "
                          placement="left"
                          :offset="-3">
                          <div slot="content">
                            <span v-if="item.status !== 1">
                              请先编辑并发布场景
                            </span>
                            <span v-if="item.defaultViewStatus === 1">
                              当前场景已经是默认场景
                            </span>
                          </div>
                          <div
                            v-if="isChecked('Project.Single.Scene.SetDefault')"
                            :class="`dropdown-item-box ${
                              item.status !== 1 || item.defaultViewStatus === 1
                                ? 'is-disabled'
                                : ''
                            }`">
                            <el-dropdown-item
                              command="5"
                              :disabled="
                                item.status !== 1 ||
                                item.defaultViewStatus === 1
                              ">
                              设为默认场景
                            </el-dropdown-item>
                          </div>
                        </el-tooltip>
                        <div v-else>
                          <div
                            v-if="isChecked('Project.Single.Scene.SetDefault')"
                            class="dropdown-item-box">
                            <el-dropdown-item command="5">
                              设为默认场景
                            </el-dropdown-item>
                          </div>
                        </div>
                        <div
                          class="dropdown-item-box"
                          v-if="item.coordinatesType !== 'None'">
                          <el-dropdown-item command="6">
                            查看坐标系
                          </el-dropdown-item>
                        </div>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="common-empty-box">
        <bj-empty
          :image="getNoDataImg()"
          class="empty-page">
          <template slot="description">
            <div
              :class="`${
                isMicroAppMode() ? 'description-box empty-text' : 'empty-text'
              }`">
              抱歉，没有找到相关内容
            </div>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import { Store } from '@/utils/store'
import EventBus from '@/utils/eventBus'
import { isMicroAppMode } from '@/microAdapt/utils'
import { formatTime, getTokenId } from '@/utils/generalMethods'

import {
  getSceneListService,
  deleteSceneService,
  batchDeleteSceneService,
  setDefaultViewService
} from '@/service/interface'

export default {
  data() {
    return {
      imageBaseUrl: `${window.imageBaseUrl}`,

      loading: true,
      isIndeterminate: false,
      checkAll: false,
      isEmpty: false,
      currentPage: 1,
      pageSize: 100,
      sceneList: [],
      selectedScenes: []
    }
  },
  props: {
    isExpired: Boolean,
    keywords: String,
    updateTotal: Function,
    openShareDialog: Function,
    openSceneNameDialog: Function,
    openSceneInfoDialog: Function,
    openCrsDialogVisible: Function
  },
  components: {
    Spin
  },
  computed: {
    isCheckAllVisible() {
      const permissionCodes = [
        'Project.Single.Scene.BatchDelete',
        'Project.Single.Scene.BatchShare'
      ]

      return permissionCodes.some(el => this.isChecked(el))
    }
  },
  mounted() {
    this.initSceneList()

    EventBus.$on('changeTheme', this.refreshSceneList)
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    initSceneList() {
      this.loading = true
      this.currentPage = 1
      this.querySceneList().then(response => {
        let { sceneList, total } = response
        this.sceneList = sceneList
        this.updateTotal(total)

        this.isEmpty = total ? false : true
        this.selectedScenes = []
        this.checkAll = false

        this.loading = false

        let timeFlag = this.sceneList.some(
          el => el.status === 2 || el.status === 3
        )
        if (timeFlag && !this.timer) {
          this.timer = setInterval(this.refreshSceneList, 1000)
        }
      })
    },
    viewScene(sceneInfo) {
      if (!this.isChecked('Project.Single.Scene.View')) {
        this.$message.error('当前用户没有查看场景的权限')
        return
      }

      let status = sceneInfo.status
      if (status === 0) {
        this.$message.warning('场景未发布，请发布后查看')
        return
      }

      if (status === 2 || status === 3) {
        this.$message.warning('场景正在发布中，请发布后查看')
        return
      }

      if (!sceneInfo.hasComponents && !sceneInfo.hasDataSets) {
        this.$message.warning('当前场景无有效数据')
        return
      }

      let projId = this.$route.params.projId
      let projName = this.$route.params.projName
      let { dataType, theme, isHeaderHidden } = this.$route.query
      let sceneId = sceneInfo.sceneId
      let viewMode = sceneInfo.displayMode
      projName = encodeURIComponent(projName)

      let url = `/singleProject/sceneView/${projId}/${projName}?sceneId=${sceneId}&viewMode=${viewMode}&dataType=${dataType}`
      if (theme) {
        url += `&theme=${theme}`
      }
      if (isHeaderHidden) {
        url += `&isHeaderHidden=false`
      }

      this.$router.push(url)
    },
    editScene(sceneInfo) {
      let projId = this.$route.params.projId
      let projName = this.$route.params.projName
      let { dataType, theme, isHeaderHidden } = this.$route.query
      let sceneId = sceneInfo.sceneId
      let viewMode = sceneInfo.displayMode
      projName = encodeURIComponent(projName)

      let url = `/singleProject/sceneEdit/${projId}/${projName}?sceneId=${sceneId}&viewMode=${viewMode}&dataType=${dataType}`
      if (theme) {
        url += `&theme=${theme}`
      }
      if (isHeaderHidden) {
        url += `&isHeaderHidden=false`
      }
      this.$router.push(url)
    },
    handleCheckChange(data, checked) {
      let findIndex = this.selectedScenes.findIndex(
        el => el.sceneId === data.sceneId
      )
      if (checked && findIndex === -1) {
        this.selectedScenes.push(data)
      }
      if (!checked && findIndex !== -1) {
        this.selectedScenes.splice(findIndex, 1)
      }

      let checkedCount = this.selectedScenes.length
      let total = this.sceneList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    handleCheckAllChange(checked) {
      if (checked) {
        let dataList = this.sceneList.map(item => item)
        let flag = dataList.every(el => el.status === 2 || el.status === 3)
        if (flag) {
          this.isIndeterminate = false
          this.checkAll = false
          this.$message.warning('当前所有场景均在发布中，请稍后再试')
          return
        } else {
          this.selectedScenes = dataList.filter(
            el => !(el.status === 2 || el.status === 3)
          )
        }
      } else {
        this.selectedScenes = []
      }

      let checkedCount = this.selectedScenes.length
      let total = this.sceneList.length
      this.checkAll = checkedCount === total
      this.isIndeterminate = checkedCount > 0 && checkedCount < total
    },
    isSceneChecked(data) {
      let find = this.selectedScenes.find(el => el.sceneId === data.sceneId)
      let checked = find ? true : false
      return checked
    },
    moreOperate(command, sceneInfo) {
      switch (command) {
        case '1':
          this.openShareDialog([sceneInfo])
          break
        case '2':
          this.openSceneNameDialog(sceneInfo)
          break
        case '3':
          this.deleteSceneBySceneId(sceneInfo)
          break
        case '4':
          this.openSceneInfoDialog(sceneInfo)
          break
        case '5':
          this.setDefaultView(sceneInfo)
          break
        case '6':
          this.openCrsDialogVisible(sceneInfo)
          break
      }

      let dom = this.$refs[`img-${sceneInfo.sceneId}`][0]
      dom.classList.remove('active')
    },
    deleteSceneBySceneId(sceneInfo) {
      this.$confirm('确定删除该场景?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let sceneId = sceneInfo.sceneId
          deleteSceneService({ sceneId }).then(response => {
            if (response.isSuccess) {
              this.initSceneList()
              this.$message.success('删除成功！！！')
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    setDefaultView(sceneInfo) {
      let defaultViewStatus = sceneInfo.defaultViewStatus
      if (defaultViewStatus === 1) {
        this.$message.error('当前场景已经是默认场景！！！')
        return
      }
      let params = {
        sceneId: sceneInfo.sceneId
      }
      setDefaultViewService(params).then(response => {
        if (response.isSuccess) {
          this.refreshSceneList()
          this.$message.success('设置默认场景成功！！！')
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchShare() {
      let scenes = this.selectedScenes
      if (!scenes.length) {
        this.$message.warning('请先选择需要分享的场景！')
        return
      }

      let invalidScenes = this.selectedScenes.filter(el => el.status !== 1)
      if (invalidScenes.length) {
        this.$message.warning('仅已发布的场景支持分享，请重新选择！')
        return
      }

      this.openShareDialog(scenes)
    },
    batchDelete() {
      let scenes = this.selectedScenes
      if (!scenes.length) {
        this.$message.warning('请先选择需要删除的场景！')
        return
      }

      this.$confirm('确定删除这些场景?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let sceneIds = scenes.map(el => el.sceneId)
          batchDeleteSceneService({ sceneIds }).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功!')
              this.initSceneList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除!')
        })
    },
    refreshSceneList() {
      this.querySceneList().then(response => {
        let { sceneList, total } = response
        let flag = sceneList.some(el => el.status === 2 || el.status === 3)
        if (!flag) {
          this.timer && clearInterval(this.timer)
          this.timer = null
        }

        this.sceneList = sceneList
        this.updateTotal(total)
      })
    },
    handleScroll() {
      if (this.allDataLoaded) return
      if (this.sceneList.length < this.pageSize) return
      this.currentPage++
      this.querySceneList().then(response => {
        let { sceneList } = response
        if (sceneList.length) {
          this.sceneList = [...this.sceneList, ...sceneList]
        } else {
          this.allDataLoaded = true
        }

        let timeFlag = this.sceneList.some(
          el => el.status === 2 || el.status === 3
        )
        if (timeFlag && !this.timer) {
          this.timer = setInterval(this.refreshSceneList, 1000)
        }
      })
    },
    querySceneList() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        let params = {
          projId,
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize,
          sceneName: this.keywords
        }
        getSceneListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let sceneList = data.items
            let total = data.totalCount
            resolve({ sceneList, total })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getSceneDefaultImg() {
      const themeName = this.$theme.get().value
      let thumbnail
      switch (themeName) {
        case 'stellar-light':
          thumbnail = require('@/assets/img/scene_default_img_light.png')
          break
        case 'dark':
          thumbnail = require('@/assets/img/scene_default_img_dark.png')
          break
      }
      return thumbnail
    },
    showImg(img) {
      const themeName = this.$theme.get().value
      switch (themeName) {
        case 'stellar-light':
          img.target.src = require('@/assets/img/scene_default_img_light.png')
          break
        case 'dark':
          img.target.src = require('@/assets/img/scene_default_img_dark.png')
          break
      }
    },
    changeStatus(data, visible) {
      let dom = this.$refs[`img-${data.sceneId}`][0]
      if (visible) {
        dom.classList.add('active')
      } else {
        dom.classList.remove('active')
      }
    },
    isEditVisible(sceneInfo) {
      const permissionCodes = [
        'Project.Single.Scene.Share',
        'Project.Single.Scene.Delete',
        'Project.Single.Scene.SetThumbnail',
        'Project.Single.Scene.SetDefault'
      ]
      let visible = permissionCodes.some(permissionCode =>
        this.isChecked(permissionCode)
      )
      if (!visible && sceneInfo.coordinatesType === 'None') {
        visible = false
      }
      return visible
    },
    getListItemClassName(sceneInfo) {
      let className = 'list-item-box'
      if (this.isExpired) {
        className += ' is-expired'
        return className
      }

      if (this.isSceneChecked(sceneInfo)) {
        className += ' activeList'
      }
      return className
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getNoDataImg() {
      if (isMicroAppMode()) {
        return require('@/assets/img/no-data-nebula.png')
      } else {
        return require('@/assets/img/no-data.png')
      }
    },
    isMicroAppMode,
    formatTime,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.card-list-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 104px);
  margin-top: 10px;
  text-align: left;

  .card-list-box {
    height: 100%;

    .card-list-content-box {
      height: 100%;

      .list-box {
        display: flex;
        height: calc(100% - 30px);
        margin-top: 10px;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: auto;

        .list-item-box {
          width: calc(100% / 6 - 20px);
          margin-right: 20px;
          margin-bottom: 20px;
          padding: 16px;
          border: 1px solid var(--sceneCard-border-color);
          border-radius: 16px;
          background: var(--sceneCard-bgColor);
          cursor: pointer;
          overflow: hidden;

          &.is-expired {
            position: relative;
            cursor: not-allowed;

            .expired-box {
              display: flex;
            }

            .img-box {
              opacity: 0.5;
              pointer-events: none;

              .default-view-box {
                display: none;
              }
            }

            .scene-info-box {
              opacity: 0.5;
              pointer-events: none;
            }
          }

          &:nth-child(6n) {
            margin-right: 0;
          }

          .expired-box {
            position: absolute;
            display: none;
            width: 81px;
            height: 18px;
            top: 14px;
            left: -18px;
            transform: rotate(-45deg);
            background: #9e9e9e;
            z-index: 999;

            .text-box {
              color: var(--aside-bg-color);
              font-size: 12px;
              font-weight: 400;
              width: 100%;
              text-align: center;
            }
          }

          .img-box {
            position: relative;
            height: 144px;

            &:hover {
              .common-checkbox-box {
                display: block;
              }

              .operation-button-box {
                display: flex;

                .edit-sence {
                  background-color: var(--base-primary-bgColor);
                  border-radius: 8px;
                  width: 32px;
                  height: 32px;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  .icon {
                    color: var(--aside-bg-color);
                    margin-left: 0;
                  }
                }
              }

              .time-box {
                display: block;
                background: var(--base-bg-dark-color7);
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                color: var(--aside-bg-color);

                &-item {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  flex-wrap: wrap;

                  span {
                    white-space: nowrap;
                  }
                }
              }

              .convert-content-box {
                display: none;
              }
            }

            &.active {
              .common-checkbox-box {
                display: block;
              }

              .operation-button-box {
                display: flex;
              }

              .time-box {
                display: block;
              }

              .convert-content-box {
                display: none;
              }
            }

            .mask-box {
              position: absolute;
              width: 100%;
              height: 100%;
              background: var(--panel-loading-bg-color);
              text-align: center;
              z-index: 2;
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 8px;
            }

            .default-view-box {
              height: 20px;
              position: absolute;
              top: -12px;
              left: -47px;
              width: 96px;
              text-align: center;
              transform: rotate(-45deg);
              color: var(--aside-bg-color);
              font-size: 12px;
              font-weight: 400;
              background: var(--base-primary-bgColor);
            }

            .common-checkbox-box {
              position: absolute;
              top: 0px;
              left: 8px;
              display: none;

              &.active {
                display: block;
              }
            }

            .operation-button-box {
              position: absolute;
              top: 0;
              right: 0;
              display: none;

              .icon {
                margin-left: 6px;
                color: var(--primary-color);
                font-size: 16px;
                line-height: 26px;
              }

              .common-dropdown-box {
                .el-dropdown {
                  margin-right: 6px;

                  // :deep(.el-icon-more) {
                  //   color: var(--sceneCard-icon-color);
                  // }
                }
              }
            }

            .time-box {
              position: absolute;
              left: 0px;
              // top: 0px;
              // right: 0;
              bottom: 0px;
              display: none;
              width: 100%;
              font-size: 12px;
              padding: 5px;
              border-radius: 4px;
            }

            .convert-content-box {
              position: absolute;
              left: 0px;
              bottom: 0px;
              width: 100%;
              font-size: 12px;
              font-weight: 400;
              padding: 5px;
              background: var(--base-bg-dark-color7);
              color: var(--aside-bg-color);
            }
          }

          @media (max-width: 1620px) {
            .img-box {
              height: 116px;
            }
          }

          .scene-info-box {
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-top: 12px;

            .scene-name-box {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 1;

              .icon-box {
                color: var(--sceneCard-icon-color);
              }

              .name-box {
                margin-left: 5px;
                padding-right: 24px;
                font-size: 12px;
                font-weight: 400;
                color: var(--sceneCard-text-color);
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }

            .status-operation {
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              margin-top: 2px;

              .common-dropdown-box {
                display: flex;
                // margin-left: 8px;
                margin-top: -16px;

                .more-info {
                  transform: rotate(90deg);

                  &-title {
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--sceneCard-icon-color);

                    &:hover {
                      border-radius: 4px;
                      background-color: var(--base-bg-light-color24);
                    }
                  }

                  &:hover {
                    :deep(.el-icon-more) {
                      color: var(--base-primary-bgColor);
                    }
                  }
                }
              }
            }

            .status-box {
              display: flex;
              align-items: center;
              font-size: 11px;
              font-weight: 400;
              margin-left: 5px;

              .circle {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                margin-right: 4px;
              }

              .icon-box {
                margin-left: 5px;
              }

              .bg-color1 {
                background: var(--table-cell-status-text-color);
              }

              .bg-color2 {
                background: var(--runing-status-color);
              }

              .bg-color3 {
                background: var(--error-status-color);
              }

              .bg-color4 {
                background: var(--success-status-color);
              }

              .color1 {
                color: var(--table-cell-status-text-color);
              }

              .color2 {
                color: var(--runing-status-color);
              }

              .color3 {
                color: var(--error-status-color);
              }

              .color4 {
                color: var(--success-status-color);
              }
            }
          }
        }

        .activeList {
          border: 1px solid var(--base-primary-bgColor);
        }
      }
    }

    .common-empty-box {
      color: var(--normal-status-color);
    }
  }
}
</style>

<style lang="less">
.custom-dropdown-primary-sceneList {
  width: 134px !important;

  .dropdown-item-box {
    width: 100%;

    &:not(.is-disabled):hover {
      background: var(--base-bg-light-color24);
      color: var(--base-primary-bgColor);
      border-radius: 4px;
    }

    .el-dropdown-menu__item {
      width: 100% !important;
      padding-right: 8px;

      &:hover {
        background: none;
      }
    }
  }
}
</style>
